// What Greenback Business costs and whether it is on sale. See
// services/publicPricingStore for when it is asked and why it never fails open.

import { useEffect, useState } from 'react';
import {
  PublicPricingState,
  ensurePublicPricingLoaded,
  getPublicPricingState,
  isBusinessOnSale,
  subscribePublicPricing,
} from '../services/publicPricingStore';

/** The price list, asked for once per page load. */
export function usePublicPricing(): PublicPricingState {
  const [current, setCurrent] = useState<PublicPricingState>(getPublicPricingState);

  useEffect(() => {
    const unsubscribe = subscribePublicPricing(setCurrent);
    ensurePublicPricingLoaded();
    // A change between the first render and this effect would otherwise be missed.
    setCurrent(getPublicPricingState());
    return unsubscribe;
  }, []);

  return current;
}

/**
 * True only once the price list says Greenback Business is on sale with a
 * priced, sellable base. False while loading, on a failure and from an older
 * api, so every button that sells it fails closed.
 */
export function useBusinessOnSale(): boolean {
  return isBusinessOnSale(usePublicPricing());
}
